import { render, staticRenderFns } from "./Timezone-Selector.vue?vue&type=template&id=147e6597&lang=pug"
import script from "./Timezone-Selector.vue?vue&type=script&lang=ts"
export * from "./Timezone-Selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports